export default __webpack_public_path__ + "static/media/vf8.413583f7.png";